import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './DefaultContactsLayout.css';

export interface IDefaultContactsLayoutProps {
  callbackButton?: React.ReactNode;
  contactsButton?: React.ReactNode;
  messageButton?: React.ReactNode;
  flatViewButton?: React.ReactNode;
  offerBookingButton?: React.ReactNode;
  wrap: boolean;
  messageButtonInSeparateRow?: boolean;
}

export const DefaultContactsLayout: React.FC<React.PropsWithChildren<IDefaultContactsLayoutProps>> = ({
  callbackButton,
  contactsButton,
  messageButton,
  flatViewButton,
  offerBookingButton,
  wrap,
  messageButtonInSeparateRow = false,
}) => {
  const buttonsRowClassName = clsx(styles['buttons-row'], { [styles['buttons-row--wrap']]: wrap });

  return (
    <div className={styles['container']}>
      {contactsButton && (
        <>
          <div className={buttonsRowClassName}>
            <div className={styles['button']}>{contactsButton}</div>
            {messageButtonInSeparateRow ? null : messageButton}
          </div>
          {messageButtonInSeparateRow && (
            <div className={buttonsRowClassName}>
              <div className={styles['button']}>{messageButton}</div>
            </div>
          )}
        </>
      )}
      <div className={buttonsRowClassName}>
        {/* TODO: В CD-235461 следующие две кнопки будут удалены отсюда. */}
        {flatViewButton && <div className={styles['button']}>{flatViewButton}</div>}
        {/* istanbul ignore next */ callbackButton && <div className={styles['button']}>{callbackButton}</div>}
        {offerBookingButton && <div className={styles['button']}>{offerBookingButton}</div>}
      </div>
    </div>
  );
};
